type Entree = { id: string; score: number; segment: string; detail: string | null; dateCalcul: string };

/**
 * Ce qu'un prospect a changé compte souvent plus que son état actuel :
 * un chatbot installé le mois dernier invalide l'accroche.
 */
export function Historique({ entrees }: { entrees: Entree[] }) {
  if (entrees.length === 0) return <p className="etat">Aucun historique : la fiche n'a été analysée qu'une fois.</p>;

  return (
    <section className="panel">
      <h2 className="blocktitle">Évolution du score</h2>
      {entrees.map((e, i) => {
        const precedent = entrees[i + 1]?.score;
        const delta = precedent !== undefined ? e.score - precedent : null;
        return (
          <div key={e.id} className="diff">
            <div className="mono petit mut">{new Date(e.dateCalcul).toLocaleDateString("fr-FR")}</div>
            <div>
              Score <strong>{e.score}</strong> · segment {e.segment}
              {delta !== null && delta !== 0 && (
                <span className={delta > 0 ? "plus" : "moins"}> ({delta > 0 ? "+" : ""}{delta})</span>
              )}
            </div>
            {e.detail && <div className="mut petit">{e.detail}</div>}
          </div>
        );
      })}
    </section>
  );
}
